import withAemIntegration from "../../withAemIntegration";
import env from "@lexus.com/ui/dist/utilities/env";

import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/FindItForMe")
);

const FindItForMeEditConfig = {
  emptyLabel: "Find-it-for-Me",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props = {}) => {

  return {
    ...props,
    form: {
      ...props.form,
      headline: props.form?.heading,
      services: ['SLP'],
      fields: props.form?.fields.map(field => {
        if (field.id === 'comments') {
          return {
            type: 'TextAreaInput',
            name: field.id,
            label: field.label,
            errorMessage: field.errorMessage,
            required: false,
          }
        }
        return {
          type: 'TextInput',
          name: field.id,
          label: field.label,
          errorMessage: field.errorMessage,
          validation: field.id,
          required: field.id !== 'phone',
        }
      }),
    }
  }
}

const FindItForMe = (props) => {
  const data = transformData(props);
  return (
    <Component
    endpoint={env("REACT_APP_GRAPHQL_ENDPOINT")}
      {...data}
    />
  );
};

export default withAemIntegration("lexus/components/find-it-for-me")(
  FindItForMe,
  FindItForMeEditConfig
);
